import { createFileRoute } from '@tanstack/react-router';
import { PersonJourneysRoute } from './-route-wrappers';

/** One journey's timeline, beneath the person profile's Journeys tab (FPS-2783). */
function PersonJourneyRoute() {
  const { personId, subjectId } = Route.useParams();

  return <PersonJourneysRoute personId={personId} subjectId={subjectId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/people/$personId/journeys/$subjectId')({
  component: PersonJourneyRoute,
});
